module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/bg-school-list-8498b6098502a9018a6c06c3515bb46d.jpg";